var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"text-left pt-4"},[_c('h3',[_vm._v("Reset")]),_c('scale-loader',{attrs:{"loading":_vm.isLoading,"color":'#007bff'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }